import script from "./CarNatur.vue?vue&type=script&lang=ts&setup=true"
export * from "./CarNatur.vue?vue&type=script&lang=ts&setup=true"

import "./CarNatur.vue?vue&type=style&index=0&id=48ea1d5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ea1d5c"]])

export default __exports__